// This file maps state to stores, and also exposes a fetchData function to fetch all
// the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';
import ActionStore from '@src/ActionStore';
import EntityStore from '@src/stores/EntityStore';
import BotSaysStore from '@src/stores/BotSaysStore';
import BotStore from '@src/store';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [
  ActionStore,
  CommonStore,
  EntityStore,
  BotSaysStore,
];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    entityDataLoading: EntityStore.getEntityLoadingStatus(),
    entityData: EntityStore.getEntityData(),
    entitiesOnNode: BotSaysStore.getEntitiesOnNode(),
    nodeDomainName: CommonStore.getMetaTags().domain.title,
    supportedLanguages: CommonStore.getSupportedLanguages(),
    allHybridLanguages: CommonStore.getAllHybridLanguages(),
    isProduction: BotStore.isProductionEnv(),
    currentBotSaysLanguage: EntityStore.getCurrentBotSaysLanguage(),
    currentHybridLanguage: EntityStore.getCurrentHybridLanguage(),
  };
}

export {
  fetchEntityData,
  clearEntityData,
  saveEntityData,
} from '@src/actions/EntityActions';
export { convertEntityCategory } from '@src/utils/NodeUtils';
export { createFileAndDownload } from '@src/utils';
export {
  updateComponentModal,
  closeComponentModal,
  createAlert,
  showConfirmationDialog,
} from '@src/actions/BotActions';

/*
TODO:
Validations on tab switch
GA Events may have been removed
*/
